import * as React from 'react'
import $ from 'jquery'
import { Row, Col, ListGroup, ListGroupItem, Input, Card, CardHeader, Badge, Label, Alert } from 'reactstrap'
import { Stepper } from '@progress/kendo-react-layout';
import { from, t, waitForCondition } from '../services/HelperService';
import { AccentDialog } from './AccentDialog';
import { AccentButton } from '../controls/AccentButton';
import { BulkUpdateCtrl, ProductChangeReviewCtrl } from '../controls/jobs/BulkUpdateCtrl';
import { MessageTypes, useMessage } from '../services/MessageService';
import {  update } from '../services/DataService';
import { getProduct, getProducts } from '../services/ProductService';
import { Helper } from '../services/JobService';


function renderProductGroup(p, clearProductSelection, onProductSelectionChanged, onSelectLine) {
    const productKey = `${p.ProductID}-${p.GroupKey}`;
    const productInputId = `bulk-prod-${productKey}`;
    const cardClassName = `bulk-product-card mb-3${p.IsSupplementaryCharge ? ' is-supplementary' : ''}`;

    return (
        <Card className={cardClassName} key={`p${productKey}`}>
            <CardHeader className="bulk-product-header d-flex align-items-center">
                <Input
                    id={productInputId}
                    className={`p-c p-${productKey} bulk-product-check me-2`}
                    type="checkbox"
                    onChange={(e) => onProductSelectionChanged({ Product: p, Value: e.target.checked })}
                />
                <Label for={productInputId} className="bulk-product-name fw-bold mb-0 flex-grow-1">
                    {p.ProductName}
                </Label>
                <Badge color="light" pill className="bulk-line-count text-dark">
                    {p.Lines.length}
                </Badge>
            </CardHeader>
            <ListGroup flush tag="div">
                {p.Lines.map((l) => {
                    return (
                        <ListGroupItem
                            key={l.ID}
                            tag="label"
                            className="bulk-line-item d-flex align-items-center mb-0"
                        >
                            <Input
                                name={l.ID}
                                className={`p-i-c p-i-${productKey} bulk-line-check me-3`}
                                type="checkbox"
                                onChange={() => { clearProductSelection(p); onSelectLine(p); }}
                            />
                            <span className="bulk-line-qty badge bg-light text-dark me-2">×{l.Qty}</span>
                            {l.Location && (
                                <span className="bulk-line-location fw-semibold me-2">{l.Location}</span>
                            )}
                            {l.BulkUpdateOptions && (
                                <span className="bulk-line-options text-muted small flex-grow-1">
                                    {l.BulkUpdateOptions}
                                </span>
                            )}
                        </ListGroupItem>
                    );
                })}
            </ListGroup>
        </Card>
    );
}

function getProductPage(products, clearProductSelection, onProductSelectionChanged, onSelectLine) {
    if (products.length == 0) {
        return (
            <div className="bulk-empty-state text-center text-muted py-5">
                <i className="fa fa-box-open fa-2x mb-3 d-block" aria-hidden="true" />
                <p className="mb-0">{t("application_strings.wizards.bulkUpdateWiz.noProducts")}</p>
            </div>
        );
    }

    const regular = products.filter(p => !p.IsSupplementaryCharge);
    const supplementary = products.filter(p => p.IsSupplementaryCharge);

    return (
        <>
            <Alert color="info" className="bulk-info-banner d-flex align-items-center mb-3">
                <i className="fa fa-info-circle me-2" aria-hidden="true" />
                <span>{t("application_strings.wizards.bulkUpdateWiz.info_1")}</span>
            </Alert>

            {regular.map(p => renderProductGroup(p, clearProductSelection, onProductSelectionChanged, onSelectLine))}

            {supplementary.length > 0 && (
                <>
                    <div className="bulk-section-header mt-4 mb-2 d-flex align-items-center">
                        <i className="fa fa-tag text-muted me-2" aria-hidden="true" />
                        <h5 className="mb-0 me-2">
                            {t("application_strings.wizards.bulkUpdateWiz.supplementaryChargesTitle")}
                        </h5>
                        <Badge color="light" pill className="text-muted me-3">
                            {supplementary.length}
                        </Badge>
                        <hr className="bulk-section-divider flex-grow-1 mb-0" />
                    </div>
                    {supplementary.map(p => renderProductGroup(p, clearProductSelection, onProductSelectionChanged, onSelectLine))}
                </>
            )}
        </>
    );
}

function getUpdatingPage(products, linesToUpdate) {


    const res = linesToUpdate.map(function (l) {

        var line = from(products).selectMany("p=>p.Lines").firstOrDefault(function (r) { return r.ID == l.ID; });

        var status = !l.UpdateCompleted ? "application_strings.wizards.bulkUpdateWiz.inProgress" : "application_strings.wizards.bulkUpdateWiz.done"
        var className = !l.UpdateCompleted ? "ql-status-inprog" : "ql-status-done"

        return (
            <Row key={l.ID}>
                <Col xs={6}>
                    {line.Qty} : {line.Location} - {line.BulkUpdateOptions}
                </Col>
                <Col xs={6} className={className}>
                    {t(status)}
                </Col>
            </Row>
        );
    });


    return res;
}



export const BulkChangeDlg = React.memo(props => {

    const [selectedProduct, setSelectedProduct] = React.useState(null);
    const [step, setStep] = React.useState(0);
    const [linesToUpdate, setLinesToUpdate] = React.useState([]);
    const [changes, setChanges] = React.useState([]);
    const updatingInprogress = React.useRef(false);
    const config = React.useRef(null);

    const updateChanged = useMessage("BulkUpdateWizard", MessageTypes.BulkUpdateChanged);


    const next = React.useCallback(async e => {

        if (step === 1) {

            await config.current?.save();

            const changes = await config.current?.getChanges();

            setChanges(changes);


            setStep(s => s + 1);

            e.promise();

            return;
        }


        if (step === 3) {
            props.onClose();
            return;
        }

        setStep(s => s + 1);
        e.promise();

    }, [step, setStep, props, config, setChanges]);


    const updateSelection = React.useCallback(e => {

        const newLinesState = [];

        $('.p-i-c').each(function (i) {
            if (this.checked) {
                var lineID = this.name;

                newLinesState.push({ ID: lineID, UpdateCompleted: false });

            }
        });

        setLinesToUpdate(newLinesState);


        setSelectedProduct(newLinesState.length > 0 ? e?.ProductID : null);


    }, [setLinesToUpdate, setSelectedProduct]);


    const clearProductSelection = React.useCallback((product) => {

        const productKey = `${product.ProductID}-${product.GroupKey}`;

        props.data.Products.forEach(function (p) {


            
            const pKey = `${p.ProductID}-${p.GroupKey}`;

            if (productKey !== pKey) {
                $(`.p-i-${p.ProductID}-${p.GroupKey}`).prop('checked', false);
                $(`.p-${p.ProductID}-${p.GroupKey}`).prop('checked', false);
            }

        });

    }, [props]);

    const onProductSelectionChanged = React.useCallback((e) => {

        $(`.p-i-${e.Product.ProductID}-${e.Product.GroupKey}`).prop('checked', e.Value);
        clearProductSelection(e.Product);

        updateSelection(e.Product);

    }, [clearProductSelection, updateSelection]);



    const onStepChanged = React.useCallback(e => {
        setStep(e.value);
    }, [setStep]);

    
    React.useEffect(() => {

        setLinesToUpdate(lines => {
            return lines.map(l => {

                if (l.ID == updateChanged.JobLineID) {
                    return { ...l, UpdateCompleted: true };
                } else {
                    return l;
                }
            });

        });


    }, [updateChanged, setLinesToUpdate]);


    React.useEffect(() => {

        if (step !== 3 || updatingInprogress.current) return;

        updatingInprogress.current = true;

        const product = getProduct(selectedProduct);



        const lineIDs = Object.keys(changes);



        const productChanges = lineIDs.map(id => {

            const lineChanges = changes[id];

            const itemChanges = lineChanges.changes.map(c => {
                return {
                    ProductOptionID: c.ProductOptionID,
                    UserSet: c.UserSet,
                    Change: {
                        ProductOptionValueID: c.ProductOptionValueID,
                        CustomValue: c.CustomValue,
                        AdditionalValue: c.AdditionalValue,
                        SupplierID: c.SupplierID,
                        Notes: ""
                    }
                }
            })


            const lineProduct = getProduct(lineChanges.productID);

            return {
                ChangeArgs: { Changes: itemChanges },
                ProductID: lineChanges.productID,
                MultiConfigID: lineChanges.multiConfigID,
                ProductURL: lineProduct.ModelURI
            };

        });


        update("PerformBulkUpdate", {
            Lines: from(linesToUpdate).select(i => i.ID).toArray(),
            ProductChanges: productChanges,
            MPResellerKeys: product.ResellerMarketplaceKeys
        }).then(res => {
            setLinesToUpdate(lines => lines.map(l => ({ ...l, UpdateCompleted: true })));          
        });

    }, [step, changes, linesToUpdate, setLinesToUpdate, selectedProduct, updatingInprogress]);


    const allowStep2 = (step === 0 || step === 1) && linesToUpdate.length > 0;
    const allowStep3 = step === 1 || step === 2;
    const allowFinish = step === 3;
    const steps = [
        {
            label: t("application_strings.wizards.bulkUpdateWiz.page1Title"),
            disabled: step > 0
        },
        {
            label: t("application_strings.wizards.bulkUpdateWiz.page2Title"),
            disabled: !allowStep2
        },
        {
            label: t("application_strings.wizards.bulkUpdateWiz.page3Title"),
            disabled: !allowStep3
        },
        {
            label: t("application_strings.wizards.bulkUpdateWiz.page4Title"),
            disabled: step !== 3
        }
    ];


    
    const allowNext = allowStep2 || allowStep3 || allowFinish;

    const btnText = step === 2 ? t("application_strings.application.buttons.update") : (step === 3) ? t("application_strings.application.buttons.finish") : t("application_strings.application.buttons.next");


    const lines = step === 2 ? config.current?.getLines() : [];

    return <AccentDialog
        fullscreen
        headerContent={t("application_strings.wizards.bulkUpdateWiz.title")}
        onClose={props.onClose}
        actionsContent={[            
            <AccentButton key="1" tagName="nextBtn" disabled={!allowNext} onClick={next}>{btnText}</AccentButton>
        ]}
    >        
        <div style={{ paddingBottom: "50px"}}>
            <Stepper value={step} onChange={onStepChanged} items={steps} />
        </div>
        <div>
            {step === 0 && getProductPage(props.data.Products, clearProductSelection, onProductSelectionChanged, updateSelection)}
            {step === 1 && <BulkUpdateCtrl ref={config} id={linesToUpdate[0].ID} businessUnitID={props.data.BusinessUnitID} companyGuid={props.data.CompanyGuid} companyID={props.data.CompanyID} />}
            {step === 2 && <ProductChangeReviewCtrl changes={changes} lines={lines} />}
            {step === 3 && getUpdatingPage(props.data.Products, linesToUpdate)} 
        </div>        
    </AccentDialog >;

});